import { oz } from '@weft/utils';
import { CreateMeasurementsPayloadSchema } from './create-measurements-payload';
import { UpdateMeasurementsPayloadSchema } from './update-measurements-payload';

export const UpsertMeasurementsPayloadSchema = oz.union([
  UpdateMeasurementsPayloadSchema,
  CreateMeasurementsPayloadSchema,
]);

export type UpsertMeasurementsPayload = oz.infer<typeof UpsertMeasurementsPayloadSchema>;